import { render } from "./CompanyDetails.vue?vue&type=template&id=16cee591&scoped=true&ts=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts"

import "./CompanyDetails.vue?vue&type=style&index=0&id=16cee591&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cee591"]])

export default __exports__